import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randAccount } from "@ngneat/falso";

export const randAccountNodeDef = createNodeDef({
  type: "randAccount",
  displayName: "Account",
  defaultName: "account",
  fields: [
    { type: DataFieldType.NUMBER, key: "accountLength", label: "Length" },
  ],
  initialData: (): { accountLength: number } => ({ accountLength: 9 }),
  generate: ({ node }) => {
    return randAccount({
      accountLength: Math.max(1, node.data.accountLength),
    });
  },
});
